/**
 * ResetPasswordModal.js
 * 
 * 檔案標頭註解：
 * 改版日期時間：2025-07-16 14:45:00
 * 版本：V1.01
 * 檔案主要功能與職責：密碼重設模態框，提供管理員為夥伴重設密碼的功能
 * 這個檔案是做什麼的？它解決了什麼問題？
 * - 提供管理員為夥伴重設密碼的介面
 * - 支援新密碼設定和驗證
 * - 提供成功和錯誤訊息顯示
 * - 確保密碼重設的安全性
 * 
 * 版本更新說明：
 * V1.01 (2025-01-16) - 初始版本，從 App.js 模組化搬移
 * 
 * 注意事項：
 * - 需要傳入 config 物件包含 vendor 資訊
 * - 需要傳入 onClose 回調函數
 * - 支援 Firebase 資料庫操作
 * - 僅供管理員使用
 * 
 * 關連檔案：
 * - App.js (主要使用此模組)
 * - Firebase 認證系統
 */

import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';

const ResetPasswordModal = ({ config, onClose, db, appId }) => {
    const { vendor } = config;
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleReset = async () => {
        setError('');
        setSuccess('');
        
        if (!newPassword) {
            return setError('新密碼不能為空！');
        }
        
        try {
            const vendorRef = doc(db, `artifacts/${appId}/public/data/vendors`, vendor.id);
            await updateDoc(vendorRef, { password: newPassword });
            setSuccess(`已為 ${vendor.name} 設定新密碼！`);
            setNewPassword('');
        } catch (err) {
            setError('密碼重設失敗: ' + err.message);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm p-6" onClick={e => e.stopPropagation()}>
                <h2 className="text-2xl font-bold mb-2 text-center">重設密碼</h2>
                <p className="text-center text-gray-600 mb-6">
                    您正在為 {vendor.name} ({vendor.id}) 重設密碼
                </p>
                <div className="space-y-4">
                    <input
                        type="password"
                        value={newPassword}
                        onChange={e => setNewPassword(e.target.value)}
                        placeholder="請輸入新密碼"
                        className="w-full p-3 border rounded-lg"
                    />
                    {error && <p className="text-red-500 text-center">{error}</p>}
                    {success && <p className="text-green-500 text-center">{success}</p>}
                    <button
                        onClick={handleReset}
                        className="w-full bg-yellow-500 text-white font-bold py-3 rounded-lg"
                    >
                        確認重設
                    </button>
                    <button
                        onClick={onClose}
                        className="w-full bg-gray-200 text-gray-800 font-bold py-2 rounded-lg mt-2"
                    >
                        關閉
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordModal; 